import { render, staticRenderFns } from "./BigScreenLayout.vue?vue&type=template&id=3dd4a702&scoped=true"
import script from "./BigScreenLayout.vue?vue&type=script&lang=js"
export * from "./BigScreenLayout.vue?vue&type=script&lang=js"
import style0 from "./BigScreenLayout.vue?vue&type=style&index=0&id=3dd4a702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd4a702",
  null
  
)

export default component.exports